import { FieldPath, FieldValues } from '@graphcommerce/ecommerce-ui'
import { FormRow } from '@graphcommerce/next-ui'
import { AddressAddition } from './AddressAddition'
import { AddressCity } from './AddressCity'
import { AddressCountryRegion } from './AddressCountryRegion'
import { AddressHousenumber } from './AddressHouseNumber'
import { AddressPostcode } from './AddressPostcode'
import { AddressStreet } from './AddressStreet'
import { AddressFieldsOptions } from './useAddressFieldsForm'
import { AddressGoogleAutoComplete } from '../../../../../components/Checkout/AddressGoogleAutocomplete'
import { useState } from 'react'

export type AddressFieldsProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = AddressFieldsOptions<TFieldValues, TName> & { countryFirst?: boolean }

export function AddressFields<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(props: AddressFieldsProps<TFieldValues, TName>) {
  const { countryFirst = true } = props
  const [autocompleteSuccess, setAutocompleteSuccess] = useState(true)

  return (
    <>
      {countryFirst && <AddressCountryRegion {...props} />}
      <FormRow>
        {/* This patch is fine for now, when upgrading to GC 9 we might consider using a replace plugin for this. */}
        <AddressGoogleAutoComplete
          {...props}
          autocompleteSuccess={autocompleteSuccess}
          setAutocompleteSuccess={setAutocompleteSuccess}
        />
      </FormRow>

      <FormRow
        sx={{
          display: !autocompleteSuccess ? 'grid' : 'none',
        }}
      >
        <AddressStreet {...props} />
        <AddressHousenumber {...props} />
        <AddressAddition {...props} />
      </FormRow>
      <FormRow
        sx={{
          display: !autocompleteSuccess ? 'grid' : 'none',
        }}
      >
        <AddressPostcode {...props} />
        <AddressCity {...props} />
      </FormRow>

      {!countryFirst && <AddressCountryRegion {...props} />}
    </>
  )
}
